import Vue from "vue";

export function isAuth(key) {
  return JSON.parse(localStorage.getItem("permissions") || "[]").indexOf(key) !== -1 || false;
}

Vue.prototype.isAuth = isAuth;
